// extracted by mini-css-extract-plugin
export default {"cartRibbon":"cartRibbon_cartRibbon__JDzLO","cartRibbon_open":"cartRibbon_cartRibbon_open__beMbU"};